module.exports = __webpack_public_path__ + "img/analytics.337fd098.svg";